import { useQuery } from 'react-query'
import { PromoCodesAPI } from '../services/api'

const usePromoCodes = () => useQuery('promoCodes', PromoCodesAPI.getPromoCodes, { staleTime: Infinity })

export { usePromoCodes }
